import { Selector } from "../../components/ui";
import { formatCountry } from "../lib/companyCatalog";

export const COMPANY_COUNTRIES = [
  "US",
  "GB",
  "CA",
  "AU",
  "NZ",
  "FR",
  "DE",
  "NL",
  "BE",
  "CH",
  "AT",
  "IE",
  "LU",
  "ES",
  "PT",
  "IT",
  "GR",
  "DK",
  "SE",
  "NO",
  "FI",
  "PL",
  "CZ",
  "JP",
  "KR",
  "CN",
  "HK",
  "SG",
  "IN",
  "BR",
  "MX",
  "ZA",
  "IL",
  "AE",
  "SA",
] as const;

export function countryCompletions(query: string): readonly string[] {
  const needle = query.trim().toLocaleLowerCase();
  if (needle === "") return COMPANY_COUNTRIES;
  return COMPANY_COUNTRIES.filter((country) =>
    formatCountry(country).toLocaleLowerCase().includes(needle),
  );
}

export default function CountrySelect({
  value,
  onChange,
  disabled = false,
}: {
  value: string;
  onChange: (country: string) => void;
  disabled?: boolean;
}) {
  const options = COMPANY_COUNTRIES.map((country) => ({
    value: country,
    label: formatCountry(country),
    searchText: country,
  }));
  return (
    <Selector
      searchable
      options={options}
      value={value as (typeof COMPANY_COUNTRIES)[number]}
      onValueChange={onChange}
      ariaLabel="Country"
      placeholder="Search country or code…"
      disabled={disabled}
      portalMenu
      className="country-autocomplete"
    />
  );
}
